<template>
  <v-container>

  </v-container>
</template>
<script>
  import Base from '../Base'
  export default {
    extends: Base,
    data () {
      return {

      }
    }
  }
</script>
